import { Extension } from '@tiptap/core'

const DIR_VALUES = new Set(['ltr', 'rtl', 'auto'])

/**
 * Keeps a stored or pasted `dir` on paragraphs and headings. The schema is the boundary: any other value is dropped,
 * and nothing here sets a direction the content did not already have.
 */
export const TextDirection = Extension.create({
  name: 'textDirection',

  addGlobalAttributes() {
    return [
      {
        types: ['paragraph', 'heading'],
        attributes: {
          dir: {
            default: null,
            parseHTML: (element: HTMLElement) => {
              const value = element.getAttribute('dir')?.toLowerCase()
              return value && DIR_VALUES.has(value) ? value : null
            },
            renderHTML: (attributes: { dir?: string | null }) => (attributes.dir ? { dir: attributes.dir } : {})
          }
        }
      }
    ]
  }
})
